export const DEFAULT_EDITOR = {
    title: 'Untitled Document',
    content: '',
};
